import React, { ReactNode } from 'react'
import clsx from 'clsx'
import { useConfig } from '@context/ConfigurationContext'
import { useStepsState } from '@context/StepsContext'
import ExternalClinicFooter from '@components/ExternalClinicFooter/ExternalClinicFooter'
import useStyles from './Page.styles'
import { useIsMultiClinicVariant } from '@hooks/useIsMultiClinicVariant'

interface Props {
  header?: ReactNode
  body: ReactNode
  footer?: ReactNode
  className?: string
  sideBar?: ReactNode
}

const PageSidebar = ({ header, body, footer, sideBar, className }: Props) => {
  const classes = useStyles()
  const { asModal } = useConfig()
  const { isInternalClinic } = useConfig()
  const isMultiClinicVariant = useIsMultiClinicVariant()
  const { step: currentStep } = useStepsState()
  const dateSelectionStep = isMultiClinicVariant ? 4 : 3
  const isDateSelectionStep = currentStep === dateSelectionStep

  return (
    <section id="availyScreen" className={clsx(classes.root, className, { [classes.modal]: asModal })}>
      {header ? <header className={classes.header}>{header}</header> : null}
      <div className={classes.withSidebarContainer}>
        {sideBar && sideBar}
        <div className={classes.withSidebarBodyContainer}>
          <main
            className={clsx(
              classes.body,
              { [classes.mobilePageWithTopPadding]: !isDateSelectionStep },
              classes.bodyFlexGrow
            )}
          >
            {body}
          </main>
          {footer ? <footer className={classes.footer}>{footer}</footer> : null}
        </div>
      </div>
      {isInternalClinic !== undefined && !isInternalClinic && <ExternalClinicFooter />}
    </section>
  )
}

export default PageSidebar
